import request from '@/utils/request1'

export function points () {
  return request({
    url: '/api/policies/points',
    method: 'post'
  })
}

export function provinces (params) {
  return request({
    url: '/api/policies/provinces',
    method: 'post',
    data: params
  })
}

export function years (params) {
  return request({
    url: '/api/policies/years',
    method: 'post',
    data: params
  })
}

export function coverLvls (params) {
  return request({
    url: '/api/policies/coverLvls',
    method: 'post',
    data: params
  })
}

export function aimLvls (params) {
  return request({
    url: '/api/policies/aimLvls',
    method: 'post',
    data: params
  })
}

export function subjects (params) {
  return request({
    url: '/api/policies/subjects',
    method: 'post',
    data: params
  })
}

export function search (params) {
  return request({
    url: '/api/policies/search',
    method: 'post',
    data: params
  })
}

export function detail (params) {
  return request({
    url: '/api/policies/detail/' + params,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/policies.js